import React from 'react';
import { IconProps } from './types';

const MainViewIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="5.75" y="5.75" width="6.5" height="6.5" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M1 5V5C1 2.79086 2.79086 1 5 1H13C15.2091 1 17 2.79086 17 5V5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17 13V13C17 15.2091 15.2091 17 13 17H5C2.79086 17 1 15.2091 1 13V13"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default MainViewIcon;
